import { InitAdminService } from '@app/admin/services/init-admin.service';
import { MessageService } from '@app/shared/services/message.service';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { CourseService } from '@app/admin/services';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
@Component({
  templateUrl: 'auction-panel.component.html',
  providers: [DatePipe],
})
export class AuctionPanelComponent implements OnInit {
  public auctions: any = [];
  public showTable: boolean;
  public dateNow = new Date();
  dataResult: boolean = false;
  public returnMessage = '';

  public auctionDashboard: any = {};

  public columns: Array<any> = [
    { title: 'Código', name: 'id', sort: 'asc', className: 'text-center' },
    { title: 'Número', name: 'code', sort: 'asc', className: 'text-center' },
    { title: 'Nome', name: 'name', sort: 'asc' },
    {
      title: 'Criado em',
      name: 'createdOn',
      sort: 'asc',
      className: 'text-center text-primary datetime',
    },
    {
      title: 'Modificado em',
      name: 'updatedOn',
      sort: 'asc',
      className: 'text-center text-primary datetime',
    },
  ];

  constructor(
    private initAdmin: InitAdminService,
    private courseService: CourseService,
    private loading: MessageService
  ) {}

  ngOnInit(): void {
    this.initAdmin.setConfigPage();
    this.dataResult = false;
    this.loadDashboard();
  }

  loadDashboard() {
    this.loading.showLoading();
    this.courseService.auctionDashboard().subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.auctionDashboard = response.data;
        } else {
          this.returnMessage = response.message;
        }
        this.loading.hideLoading();
      },
      (error) => {
        this.loading.hideLoading();
        this.showTable = false;
        this.returnMessage =
          'Erro ao carregar os dados do dashboard de leilões.';
      }
    );
  }
}
